module.exports = __webpack_public_path__ + "assets/img/smartTV-module4-8.024cb4e6.jpg";